<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    console.log("250331-1");
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue